<!--
  We loop over each "row" in our rows array.
  Then we loop over each "value" in the row.
  We use <app-input-display> to show each value.
-->
<ng-container *ngFor="let row of rows; let i = index">
  <div class="input-display-grid row">
    <ng-container *ngFor="let value of row; let j = index">
      <p-skeleton *ngIf="loading" width="100px" height="1.5rem"></p-skeleton>

      <app-input-display
        *ngIf="!loading"
        [label]="value.label"
        [value]="value.value"
        [valueComponent]="value.valueComponent"
        [includeMargin]="includeMargin"
        style="margin-right: 10px">
      </app-input-display>
    </ng-container>
  </div>
</ng-container>
